<!-- Profile Table -->
<mat-table *ngIf="tableData" [dataSource]="tableData" multiTemplateDataRows>

    <!-- More Column -->
    <ng-container matColumnDef="more">
        <mat-header-cell *matHeaderCellDef translate>
            More
        </mat-header-cell>
        <mat-cell *matCellDef="let topic">
            <ng-container *ngIf="topic.subLevelNodes.length > 0">
                <span class="material-icons" [ngClass]="{
                    'detail-row-expanded-icon': tableData.checkExpanded(topic),
                    'detail-row-collapsed-icon': !tableData.checkExpanded(topic)
                }"></span>
            </ng-container>
        </mat-cell>
    </ng-container>

    <!-- Topic Column -->
    <ng-container matColumnDef="topic">
        <mat-header-cell *matHeaderCellDef translate> Topic </mat-header-cell>
        <mat-cell *matCellDef="let topic">
            {{topic.topLevelNode.data.Title}}
            <ng-container *ngIf="isViewing && topic.topLevelNode.data.Image">
                <img style="max-height: 64px; max-width: 64px;"
                    [src]="resourceSrc(topic.topLevelNode)" />
            </ng-container>
        </mat-cell>
    </ng-container>

    <!-- Inactive Column -->
    <ng-container matColumnDef="inactive">
        <mat-header-cell *matHeaderCellDef translate style="min-width:95px"> Inactive </mat-header-cell>
        <mat-cell *matCellDef="let topic" style="min-width:95px">
            {{topic.topLevelNode.data.Status == 'I' ? 'Y' : ''}}
        </mat-cell>
    </ng-container>

    <!-- Actions Column -->
    <ng-container matColumnDef="actions">
        <mat-header-cell *matHeaderCellDef translate> Actions </mat-header-cell>
        <mat-cell *matCellDef="let topic">
            <button [matMenuTriggerFor]="actionMenu"
                [matMenuTriggerData]="{
                    node: topic.topLevelNode,
                    topLevelNode: true
                }"
                style="cursor: pointer"
                (click)="$event.stopPropagation()"
                *ngIf="userCanEdit">
                <img src="./assets/images/actions.png" 
                    style="width: 30px; height: 30px;"
                    alt="actions"
                    tabindex="0" />
            </button>
            <img src="./assets/images/actions disabled.png"
                style="width: 30px; height: 30px;"
                alt="actions disabled"
                *ngIf="!userCanEdit" />
        </mat-cell>
    </ng-container>

    <!-- Expand Row -->
    <ng-container matColumnDef="expandedRow">
        <td mat-cell 
            *matCellDef="let topic" 
            class="mat-detail-card"
            [attr.colspan]="topicColumns.length">
            
            <!-- Recursive Table without header for viewing -->
            <ng-container *ngIf="isViewing">
                <ng-container 
                *ngTemplateOutlet="dataTable; context: {
                    node: topic.topLevelNode,
                    topic: topic
                }"></ng-container>
            </ng-container>

            <!-- Sub Profile Table -->
            <mat-table *ngIf="topic.topLevelNode.children.length > 0 && !isViewing" 
                [dataSource]="topic.topLevelNode.subTableData"
                [ngStyle]="{'min-width': profileTableWidth + 'px'}"
                multiTemplateDataRows>

                <!-- More Column -->
                <ng-container matColumnDef="more">
                    <mat-header-cell *matHeaderCellDef translate> More </mat-header-cell>
                    <mat-cell *matCellDef="let node">
                        <ng-container *ngIf="node.children.length > 0">
                            <p class="material-icons" [ngClass]="{
                                'detail-row-expanded-icon': node.parent.subTableData.checkExpanded(node),
                                'detail-row-collapsed-icon': !node.parent.subTableData.checkExpanded(node)
                            }"></p>
                        </ng-container>
                    </mat-cell>
                </ng-container>

                <!-- Content Title Column -->
                <ng-container matColumnDef="content title">
                    <mat-header-cell *matHeaderCellDef translate>Content Title</mat-header-cell>
                    <mat-cell *matCellDef="let node">
                        {{node.data.Title}}
                        <ng-container *ngIf="node.data.Image && isViewing">
                            <br />
                            <img class="contentImage"
                                [src]="resourceSrc(node)" />
                        </ng-container>
                    </mat-cell>
                </ng-container>

                <!-- Inactive Column -->
                <ng-container matColumnDef="inactive">
                    <mat-header-cell *matHeaderCellDef translate> Inactive </mat-header-cell>
                    <mat-cell *matCellDef="let node">
                        {{node.data.Status == 'I' ? 'Y' : ''}}
                    </mat-cell>
                </ng-container>

                <!-- Start Date Column -->
                <ng-container matColumnDef="start date">
                    <mat-header-cell *matHeaderCellDef translate>Start</mat-header-cell>
                    <mat-cell *matCellDef="let node">
                        {{node.data.DateFromView && node.data.DateFromView.toString() != junkDate.toString() ? 
                            (node.data.DateFromView | date: 'MM/dd/yy') : 
                            ''}}
                    </mat-cell>
                </ng-container>

                <!-- End Date Column -->
                <ng-container matColumnDef="end date">
                    <mat-header-cell *matHeaderCellDef translate>End</mat-header-cell>
                    <mat-cell *matCellDef="let node">
                        {{node.data.DateToView && node.data.DateToView.toString() != junkDate.toString() ? 
                            (node.data.DateToView  | date: 'MM/dd/yy') : 
                            ''}}
                    </mat-cell>
                </ng-container>

                <!-- Attacments Colmumn -->
                <ng-container matColumnDef="attachments">
                    <mat-header-cell *matHeaderCellDef translate>
                        <img src="./assets/images/paperclip.png" alt="paperclip" style="height: 20px" />
                    </mat-header-cell>
                    <mat-cell *matCellDef="let node">
                        {{node.data.ProfileAttachments && node.data.ProfileAttachments.length > 0 ? node.data.ProfileAttachments.length : ''}}
                    </mat-cell>
                </ng-container>

                <!-- Actions Column -->
                <ng-container matColumnDef="actions">
                    <mat-header-cell *matHeaderCellDef translate> Actions </mat-header-cell>
                    <mat-cell *matCellDef="let node">
                        <button [matMenuTriggerFor]="actionMenu"
                            [matMenuTriggerData]="{
                                node: node,
                                topLevelNode: false
                            }"
                            style="cursor: pointer"
                            (click)="$event.stopPropagation()"
                            *ngIf="userCanEdit && !isViewing">
                            <img src="./assets/images/actions.png" 
                                style="width: 30px; height: 30px;"
                                alt="actions"
                                tabindex="0" />
                        </button>
                        <img src="./assets/images/actions disabled.png"
                            style="width: 30px; height: 30px;"
                            alt="actions disabled"
                            *ngIf="!userCanEdit && !isViewing" />
                    </mat-cell>
                </ng-container>

                <!-- Attachments Link -->
                <ng-container matColumnDef="attachments link">
                    <mat-header-cell *matHeaderCellDef translate> Attachments </mat-header-cell>
                    <mat-cell *matCellDef="let node">
                        <a class="viewAttachmentsLink"
                            *ngIf="V10 ? ((isViewing && node.data.parentViewableAttachments.length > 0) || (!isViewing && node.data.ProfileAttachments.length > 0)) : ((!isStaff && node.data.parentViewableAttachments.length > 0) || (!isStaff && node.data.ProfileAttachments.length > 0))"
                            (click)="showAttachments(node.data)"
                            translate>
                            View Attachments
                        </a>
                    </mat-cell>
                </ng-container>

                <!-- Expand Row -->
                <ng-container matColumnDef="expandRow">
                    <td mat-cell 
                        *matCellDef="let node" 
                        class="mat-nested-detail-card"
                        [attr.colspan]="profileColumns.length">
                        <ng-container 
                            *ngTemplateOutlet="dataTable; context: {
                                node: node,
                                topic: topic
                            }"></ng-container>
                </ng-container>

                <!-- Row Definitions -->
                <mat-header-row *matHeaderRowDef="profileColumns"></mat-header-row>
                <mat-row *matRowDef="let row; columns: profileColumns;"
                    [ngStyle]="{
                        'border-bottom': borderBottom ? '' : 'none'
                    }"
                    tabindex="0" 
                    style="cursor: pointer"
                    [ngClass]="{
                        'detailRowOpened': row.parent.subTableData.checkExpanded(row) && row.children && row.children.length > 0 
                    }"
                    id="row{{row.data.RowId}}"
                    [attr.aria-label]="'profile ' + row.data.Title + '.' + (row.children.length > 0 ? ' Press Enter to view details.' : '')"
                    (click)="
                        row.children.length > 0 ? row.parent.subTableData.toggleExpanded(row) : null;
                    "></mat-row>
                <mat-row *matRowDef="let row; columns: ['expandRow']"
                    class="mat-detail-row"
                    [@detailExpand]="row.parent.subTableData.checkExpanded(row) ? 'expanded' : 'collapsed'"
                    [ngStyle]="{
                        'width': tableData.checkExpanded(row) ? '100%' : '0%',
                        'border-bottom': borderBottom ? '' : 'none',
                        'display': row.children && row.children.length > 0 ? '' : 'none'
                        
                    }"
                    style="overflow: hidden"></mat-row>
            </mat-table>
        </td>
    </ng-container>

    <!-- Row Definitions -->
    <ng-container *ngIf="!isViewing">
        <mat-header-row *matHeaderRowDef="topicColumns"></mat-header-row>
    </ng-container>
    <mat-row *matRowDef="let row; columns: topicColumns;"
        tabindex="0" 
        style="cursor: pointer"
        [ngClass]="{
            'detailRowOpened': tableData.checkExpanded(row) && row.topLevelNode && row.topLevelNode.children.length > 0
        }"
        [ngStyle]="{
            'border-bottom': borderBottom ? '' : 'none'
        }"
        id="row{{row.topLevelNode.data.RowId}}"
        [attr.aria-label]="'topic ' + row.topLevelNode.data.Title + '.' + (row.subLevelNodes.length > 0 ? ' Press Enter to view details.' : '')"
        (click)="
            row.subLevelNodes.length > 0 ? tableData.toggleExpanded(row) : null;
        "></mat-row>
    <mat-row *matRowDef="let row; columns: ['expandedRow']"
        class="mat-detail-row"
        [ngStyle]="{
            'display': row.topLevelNode && row.topLevelNode.children.length > 0 ? '' : 'none',
            'border-bottom': borderBottom ? '' : 'none'
        }"
        [@detailExpand]="tableData.checkExpanded(row) ? 'expanded' : 'collapsed'"
        style="overflow: hidden"></mat-row>
</mat-table>

<!-- Recursive Table Data -->
<ng-template #dataTable let-node="node" let-topic="topic">
    <mat-table *ngIf="node.children.length > 0" 
        [dataSource]="node.subTableData"
        [ngStyle]="{'min-width': profileTableWidth + 'px'}"
        multiTemplateDataRows>

        <!-- More Column -->
        <ng-container matColumnDef="more">
            <mat-cell *matCellDef="let node" style="align-self: self-start">
                <ng-container *ngIf="node.children.length > 0">
                    <p class="material-icons" [ngClass]="{
                        'detail-row-expanded-icon': node.parent.subTableData.checkExpanded(node),
                        'detail-row-collapsed-icon': !node.parent.subTableData.checkExpanded(node)
                    }"></p>
                </ng-container>
            </mat-cell>
        </ng-container>

        <!-- Content Title Column -->
        <ng-container matColumnDef="content title">
            <mat-cell *matCellDef="let node">
                <div *ngIf="isViewing" style="margin-top: 10px">
                    <b>{{node.data.Title}}</b>
                    <br />
                    <div style="padding-top: 10px; display: flex;">
                        <img style="display: inline-block;"  
                            *ngIf="node.data.Image"
                            class="contentImage"
                            [src]="resourceSrc(node)" />
                        <tyl-quill-text-only style="display: inline-block;"
                            [padding]="10"
                            [html]="node.data.Content"></tyl-quill-text-only>
                    </div>
                </div>
                <ng-container *ngIf="!isViewing">
                    {{node.data.Title}}
                </ng-container>
            </mat-cell>
        </ng-container>

        <!-- Inactive Column -->
        <ng-container matColumnDef="inactive">
            <mat-header-cell *matHeaderCellDef translate> Inactive </mat-header-cell>
            <mat-cell *matCellDef="let node">
                {{node.data.Status == 'I' ? 'Y' : ''}}
            </mat-cell>
        </ng-container>

        <!-- Start Date Column -->
        <ng-container matColumnDef="start date">
            <mat-header-cell *matHeaderCellDef translate>Start</mat-header-cell>
            <mat-cell *matCellDef="let node">
                {{node.data.DateFromView && node.data.DateFromView.toString() != junkDate.toString() ? 
                    (node.data.DateFromView | date: 'MM/dd/yy') :
                    ''}}
            </mat-cell>
        </ng-container>

        <!-- End Date Column -->
        <ng-container matColumnDef="end date">
            <mat-header-cell *matHeaderCellDef translate>End</mat-header-cell>
            <mat-cell *matCellDef="let node">
                {{node.data.DateToView && node.data.DateToView.toString() != junkDate.toString() ? 
                    (node.data.DateToView | date: 'MM/dd/yy') :
                    ''}}
            </mat-cell>
        </ng-container>

        <!-- Attacments Colmumn -->
        <ng-container matColumnDef="attachments">
            <mat-header-cell *matHeaderCellDef translate>
                <img src="./assets/images/paperclip.png" alt="paperclip" style="height: 20px" />
            </mat-header-cell>
            <mat-cell *matCellDef="let node">
                {{node.data.ProfileAttachments && node.data.ProfileAttachments.length > 0 ? node.data.ProfileAttachments.length : ''}}
            </mat-cell>
        </ng-container>

        <!-- Actions Column -->
        <ng-container matColumnDef="actions">
            <mat-header-cell *matHeaderCellDef translate> Actions </mat-header-cell>
            <mat-cell *matCellDef="let node">
                <button [matMenuTriggerFor]="actionMenu"
                    [matMenuTriggerData]="{
                        node: node,
                        topLevelNode: false
                    }"
                    style="cursor: pointer"
                    (click)="$event.stopPropagation()"
                    *ngIf="userCanEdit && !isViewing">
                    <img src="./assets/images/actions.png" 
                        style="width: 30px; height: 30px;"
                        alt="actions"
                        tabindex="0" />
                </button>
                <img src="./assets/images/actions disabled.png"
                    style="width: 30px; height: 30px;"
                    alt="actions disabled"
                    *ngIf="!userCanEdit && !isViewing" />
            </mat-cell>
        </ng-container>

        <!-- Attachments Link -->
        <ng-container matColumnDef="attachments link">
            <mat-header-cell *matHeaderCellDef translate> Attachments </mat-header-cell>
            <mat-cell *matCellDef="let node">
                <a class="viewAttachmentsLink"
                    *ngIf="(V10 ? (node.data.ProfileAttachments.length > 0 ) : (!isStaff && node.data.parentViewableAttachments.length > 0) || (isStaff && node.data.ProfileAttachments.length > 0) )"
                    (click)="showAttachments(node.data)"
                    translate>
                    View Attachments
                </a>
            </mat-cell>
        </ng-container>

        <!-- Expand Row -->
        <ng-container matColumnDef="expandRow">
            <td mat-cell 
                *matCellDef="let node" 
                [attr.colspan]="profileColumns.length"
                class="mat-nested-detail-card">
                <ng-container *ngIf="node.children.length > 0">
                    <ng-container 
                        *ngTemplateOutlet="dataTable; context: {
                            node: node,
                            topic: topic
                        }"></ng-container>
                </ng-container>
        </ng-container>

        <!-- Row Definitions -->
        <mat-row *matRowDef="let row; columns: profileColumns;"
            tabindex="0" 
            style="cursor: pointer"
            [ngClass]="{
                'detailRowOpened': row.parent.subTableData.checkExpanded(row) && row.children && row.children.length > 0
            }"
            [ngStyle]="{
                'border-bottom': borderBottom ? '' : 'none'
            }"
            id="row{{row.data.RowId}}"
            [attr.aria-label]="'profile ' + row.data.Title + '.' + (row.children.length > 0 ? ' Press Enter to view details.' : '')"
            (click)="
                row.children.length > 0 ? row.parent.subTableData.toggleExpanded(row) : null;
            "></mat-row>
        <mat-row *matRowDef="let row; columns: ['expandRow']"
            [ngStyle]="{
                'border-bottom': borderBottom ? '' : 'none',
                'display': row.children && row.children.length > 0 ? '' : 'none'
            }"
            class="mat-detail-row"
            [@detailExpand]="row.parent.subTableData.checkExpanded(row) ? 'expanded' : 'collapsed'"></mat-row>
    </mat-table>
</ng-template>

<!-- Action Menu -->
<mat-menu #actionMenu>
	<ng-template matMenuContent let-node="node" let-topLevelNode="topLevelNode">
        <button *ngIf="node.getNestedLayers() < 4" 
            mat-menu-item 
            class="sis-app-menu" 
            tabindex="0" 
            (click)="addContent(node)"
            translate>
            Add <i>{{node.data.Title}}</i> Content
        </button>
        <button *ngIf="V10 && !topLevelNode" 
            mat-menu-item class="sis-app-menu" 
            role="menuitem" 
            tabindex="0" 
            (click)="showAttachments(node.data)"
            translate>
            Attachments
        </button>
        <button mat-menu-item 
            class="sis-app-menu" 
            role="menuitem" 
            tabindex="0" 
            (click)="topLevelNode ? editTopic(node.data) : editContent(node.data)"
            translate>
            Edit
        </button>
        <button mat-menu-item 
            class="sis-app-menu" 
            role="menuitem" 
            tabindex="0"
            *ngIf="topLevelNode ? !node.topic.last : !node.last"
            style="cursor: pointer"
            (click)="topLevelNode ? moveRowDown(node.topic) : moveContentRowDown(node)"
            translate>
            Move Row Down
        </button>
        <button mat-menu-item 
            class="sis-app-menu" 
            role="menuitem" 
            tabindex="0"
            *ngIf="topLevelNode ? node.topic.last : node.last"
            style="color: grey"
            translate>
            Move Row Down
        </button>
        <button mat-menu-item 
            class="sis-app-menu" 
            role="menuitem" 
            tabindex="0"
            *ngIf="topLevelNode ? !node.topic.first : !node.first"
            style="cursor: pointer"
            (click)="topLevelNode ? moveRowUp(node.topic) : moveContentRowUp(node)"
            translate>
            Move Row Up
        </button>
        <button mat-menu-item 
            class="sis-app-menu" 
            role="menuitem" 
            tabindex="0"
            *ngIf="topLevelNode ? node.topic.first : node.first"
            style="color: grey"
            translate>
            Move Row Up
        </button>
        <mat-divider>
        </mat-divider>
        <button mat-menu-item
            class="sis-app-menu"
            role="menuitem"
            tabindex="0"
            (click)="deleteTopic(node.data)"
            translate>
            Delete
        </button>
	</ng-template>
</mat-menu>
